/* @flow */

import { compose } from 'ramda';
import * as React from 'react';

import IntroScreen from './intro/IntroScreen';
import LazyLoginMain from 'src/shared/app/authentication/component/login/LazyLoginMain';
import useFeatureDecisions from 'src/shared/app/feature/hook/useFeatureDecisions';
import LazySignupMain from 'src/shared/app/signup/component/LazySignupMain';

type Props = {
  handleOnboardingComplete: () => void,
};

const OnboardingMainDumb = ({
  handleOnboardingComplete,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const { isSignupEnabled } = useFeatureDecisions();

  /*
   |----------------------------------------------------------------------------
   | Effects
   |----------------------------------------------------------------------------
   */

  React.useEffect(() => {
    if (isSignupEnabled) {
      LazySignupMain.preload();
    } else {
      LazyLoginMain.preload();
    }
  }, [isSignupEnabled]);

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return <IntroScreen handleClick={handleOnboardingComplete} />;
};

export default compose(React.memo)(OnboardingMainDumb);
